export var JabraNativeCommands;
(function (JabraNativeCommands) {
    JabraNativeCommands["Ring"] = "ringer";
    JabraNativeCommands["Offhook"] = "offhook";
    JabraNativeCommands["Mute"] = "mute";
    JabraNativeCommands["Hold"] = "hold";
})(JabraNativeCommands || (JabraNativeCommands = {}));
export const HeadsetEvent = 'JabraEvent';
export const DeviceEvent = 'JabraDeviceAttached';
export var JabraNativeEventNames;
(function (JabraNativeEventNames) {
    JabraNativeEventNames["OffHook"] = "OffHook";
    JabraNativeEventNames["Mute"] = "Mute";
    JabraNativeEventNames["Hold"] = "Flash";
    JabraNativeEventNames["RejectCall"] = "RejectCall";
})(JabraNativeEventNames || (JabraNativeEventNames = {}));
//# sourceMappingURL=types.js.map